import CardSide from '@components/membership/CardSide';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

interface Props {
    count: number;
    hide?: boolean;
    shopName: string;
}

function SummaryCard({
    count, hide, shopName,
}:Props) {
    const { t } = useTranslation('stamp');
    return (
        <Wrapper isHide={hide}>
            <Contents>
                <TopRow>
                    <Bar/>
                    <Side color={colors.gray4}/>
                    <ShopText>{shopName}</ShopText>
                </TopRow>
                <Base/>
                <Overlay/>
                <CountWrapper >
                    <Text size='lg' fontWeight='bold' color={colors.gray7}>
                        {count}{t('card.countUnit')}
                    </Text>
                </CountWrapper>
            </Contents>
        </Wrapper>
    );
}

const Wrapper = styled.div<{isHide?: boolean}>`
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    transition: 50ms;
    width: 100%;
    max-height: ${({ isHide }) => (isHide ? 0 : 200)}px;
`;

const Contents = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    width: 100%;
`;

const TopRow = styled(Row)`
    margin-bottom: -1px;
`;

const Bar = styled.div`
    background-color: var(--color-gray4);
    border-top-left-radius: 12px;
    height: 17px;
    flex: 1;
    margin-bottom: -1px;
`;

const Base = styled.div`
    background-color: var(--color-gray4);
    border-radius: 0 12px 12px 12px;
    height: 36px;
    width: 100%;
`;

const Overlay = styled.div`
    inset: 0;
    mix-blend-mode: overlay;
    pointer-events: none;
    position: absolute;
    z-index: 2;
    background: linear-gradient(180deg, var(--color-gray5) 33.17%, var(--color-gray3) 100%);
`;

const CountWrapper = styled.div`
    position: absolute;
    left: 16px;
    z-index: 3;
`;

const ShopText = styled(Text)`
    margin-right: 4px;
    margin-top: -9px;
    opacity: 0;
`;

const Side = styled(CardSide)`
    margin-bottom: -2px;
    margin-left: -2px;
`;

export default SummaryCard;
